import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import mutations from './mutations'
import actions from './actions'

const vuexPersist = new VuexPersist({
    key: 'solfile-app',
    storage: window.localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isAuth: localStorage.getItem('token'),
		token: localStorage.getItem('token')
    },
    mutations: mutations,
    actions: actions,
    plugins: [vuexPersist.plugin]
})
